// extracted by mini-css-extract-plugin
export var container = "_eh-1";
export var cornerButtonContainer = "_eh-6";
export var disabled = "_eh-2";
export var dragActive = "_eh-3";
export var fileContainer = "_eh-5";
export var hiddenInput = "_eh-4";
export var widthContainer = "_eh-0";